import {Translation} from "react-i18next";

export default Translation;
